var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlash = function SvgFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.744 2.093a.75.75 0 0 0-1.32-.573l-10 12A.75.75 0 0 0 3 14.75h8.15l-.894 7.157a.75.75 0 0 0 1.32.573l10-12A.75.75 0 0 0 21 9.25h-8.15zm-1.182 11.41A.75.75 0 0 0 12 13.25H4.601l7.337-8.805-.682 5.462a.75.75 0 0 0 .744.843h7.399l-7.337 8.805.682-5.462a.75.75 0 0 0-.182-.59",
    clipRule: "evenodd"
  })));
};
export default SvgFlash;